import React, { useEffect, useState } from 'react'
import useAuth from 'src/hooks/useAuth'

const TopMenu = () => {

  const { languageToggler, setLanguageToggler } = useAuth()
  const [selectedLanguage, setSelectedLanguage] = useState(null)

  const handleClick = (lang) => {
    localStorage.setItem('lang', lang)
    setLanguageToggler(!languageToggler)
  }

  useEffect(() => {
    let language = localStorage.getItem('lang')
    setSelectedLanguage(language)
  }, [languageToggler])


  return (
    <div className='d-flex justify-content-end py-1' style={{ backgroundColor: "#322053" }}>
      <div className='d-flex'>
        <div>
          <small role="button" className={`text-white  border-end pe-2 ${selectedLanguage === "en" ? "fw-bold" : null}`} onClick={() => handleClick('en')}>
            English
          </small>
        </div>
        <div>
          <small role="button" className={`text-white border-end px-2 ${selectedLanguage === "it" ? "fw-bold" : null}`} onClick={() => handleClick('it')} >
            Italian
          </small>
        </div>
        <div>
          <small role="button" className={`text-white border-end px-2 ${selectedLanguage === "nl" ? "fw-bold" : null}`} onClick={() => handleClick('nl')}>
            Dutch
          </small>
        </div>
        <div>
          <small role="button" className={`text-white border-end px-2 ${selectedLanguage === "de" ? "fw-bold" : null}`} onClick={() => handleClick('de')}>
            German
          </small>
        </div>
        <div>
          <small role="button" className={`text-white border-end px-2 ${selectedLanguage === "ro" ? "fw-bold" : null}`} onClick={() => handleClick('ro')}>
            Romanian
          </small>
        </div>
      </div>
    </div>
  )
}

export default TopMenu